
// import { Product } from './provider.product';
import * as http from 'gs-browser-http';
import { cfg } from '../config';
import { globalOnSubmitCallback, globalDebugFlag } from '../module';

//  http://147.102.110.48:15082/api/rest/v1/theme/elevation/product/solar/{"sb":true,"operator":"for","value":{"geom":{"type":"Polygon","coordinates":[[[-2.34741,51.37783],[-2.34361,51.37869],[-2.34347,51.37961],[-2.34489,51.3807873],[-2.34664,51.38079],[-2.34810,51.38015],[-2.34741,51.37783]]]}}}
let url = "http://147.102.110.48:15082/api/rest/v1/theme/elevation/product/solar/";
url = "http://147.102.110.48:15082/api/rest/v1/theme/b2b/product/vineyard/";
url = cfg.apiUrlBase + "/api/rest/v1/theme/b2b/product/vineyard/";

class ProviderSubmit {

    debugTimerHandle: any;

    constructor() {
    }

    submit(area: number, geom: number[][], productsId: string[], _product_selected_dataset: { theme: string, id: string }[], name: string) {
        // console.log(geom);
        console.log(area, geom, productsId);

        let params = {
            "sb": true,
            "operator": "for",
            "value": {
                "geom": {
                    "type": "Polygon",
                    "coordinates": [geom]
                }
            },
            "params": {
                "products": productsId,
                "datasets": _product_selected_dataset,
                "area": Math.round(area / 1000) * 1000,
                "name": name
            }
        };
        console.log(params);
        // console.log(url + JSON.stringify(params));
        http.GET(url + JSON.stringify(params)).then(r => {

            let content: { id: string, status: string, trigger: string } = JSON.parse(r.data);
            console.log(content);
            // this._max_area = content.max_area;
            // let modules: Product[] = content.modules.map(m => {
            //     var tmp_price_function: ((quantity: number) => number) = (quantity: number) => { return 0; };
            //     eval(`tmp_price_function = function(q){ return ${m.price};};`);
            //     let out = { id: m.id, name: m.name, fixed: m.fixed, price: tmp_price_function, dataset: m.dataset, max_area: m.max_area };
            //     return out;
            // })
            // this.products = [];
            // this.products.push(...modules);

            let ar = Math.round(area / 1000) * 1000;
            globalOnSubmitCallback({ id: content.id, area: ar, products: productsId });
            this.triggerDebugChain(content.id);
        });


    }





    async triggerDebugChain(id: string) {
        if (globalDebugFlag) {
            let url = cfg.apiUrlBase + "/api/rest/v1/job/" + id + "/trigger"

            let jwt = 'jwt=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3N1ZXIiOiJ2aW5lc2NhcGVzIiwiZW1haWwiOiJpb2FubmlzQG1hcGxvb20uY29tIiwiaWQiOiJWUzAwMDAwMDEiLCJuYW1lIjoiSW9hbm5pcyBTb2ZvcyIsInRlbGVwaG9uZSI6IjY5MDY1NjM5NDciLCJpYXQiOjE1NTExMjMzMTN9.1vBjySV_C0yN4REpk0EzsyTdB-5UmdipoUPh5FsUxTs';
            await http.POST(url, jwt);
            // await http.GET(url);
            // console.log(data);

            this.debugTimerHandle = setInterval(() => {
                this.debugReadStatus(id);
            }, 3000);
        }
    }

    async debugReadStatus(id: string) {
        let url = cfg.apiUrlBase + "/api/rest/v1/job/" + id + "/status"
        // console.log(url);
        let d = await http.GET(url)
        // console.log(d);
        let status: { status: "complete", progress: number } = JSON.parse(d.data);
        console.log(status);
        if (status.status === "complete" && status.progress === 1) {
            clearInterval(this.debugTimerHandle);
            this.debugReadResult(id);
        }
    }

    async debugReadResult(id: string) {
        let url = cfg.apiUrlBase + "/api/rest/v1/job/" + id + "/result"
        // console.log(url);
        let d = await http.GET(url)
        // console.log(d);
        let res: { url: string } = JSON.parse(d.data);
        console.log(res);
        window.open(res.url);
    }



}

export let providerSubmit = new ProviderSubmit();